module.exports = __webpack_public_path__ + "img/titleNew-hover.cac92db8.png";